import React from "react";
import { Settings } from "@mui/icons-material";
import { Container } from "@mui/material";
import { DocumentTitle } from "~/components/document-title";
import * as Layout from "~/layout";
import { SettingsSidebar } from "~/settings";
import { DataStoreCreateForm } from "./DataStoreCreateForm";

export function DataStoreCreatePage() {
  return (
    <>
      <DocumentTitle>New DataStore</DocumentTitle>
      <Layout.LayoutStateProvider>
        <Layout.Root>
          <Layout.Navigation />
          <Layout.Header
            title="New DataStore"
            actions={
              <Layout.SidebarTrigger
                sidebarId="settings"
                title="Settings"
                icon={<Settings />}
              />
            }
          />
          <Layout.Main>
            <Layout.ScrollableContainer>
              <Container fixed>
                <DataStoreCreateForm />
              </Container>
            </Layout.ScrollableContainer>
          </Layout.Main>
          <Layout.Sidebar>
            <Layout.SidebarSwitch
              options={[
                { sidebarId: "settings", element: <SettingsSidebar /> },
              ]}
            />
          </Layout.Sidebar>
        </Layout.Root>
      </Layout.LayoutStateProvider>
    </>
  );
}
